import React, { useState, useRef } from "react";

export default function ZoomebleImage({ src, zoom = 3, lensSize = 90, zoomWidth = 600, zoomHeight = 600 }) {
    const imgRef = useRef(null);
    const img = imgRef.current;

    const [show, setShow] = useState(false);
    const [pos, setPos] = useState({ x: 0, y: 0 });
    const [zoomPos, setZoomPos] = useState({ left: 0, top: 0 });
    const half = lensSize / 2;

    const handleMove = e => {
        const rect = imgRef.current.getBoundingClientRect();

        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;

        x = Math.max(half, Math.min(x, rect.width - half));
        y = Math.max(half, Math.min(y, rect.height - half));

        setPos({ x, y });
        const showRight = rect.left < window.innerWidth / 2;

        setZoomPos({
            top: rect.top,
            left: showRight
                ? rect.right + 15
                : rect.left - zoomWidth - 15
        });
    };

    let bgPos = "0% 0%";

    if (img) {
        // ratio of lens center relative to image
        const rx = (pos.x - half) / (img.clientWidth - lensSize);
        const ry = (pos.y - half) / (img.clientHeight - lensSize);

        // clamp ratio
        const clampX = Math.max(0, Math.min(rx, 1));
        const clampY = Math.max(0, Math.min(ry, 1));

        bgPos = `${clampX * 100}% ${clampY * 100}%`;
    }

    return (
        <>

            {/* IMAGE */}
            <div
                style={{ position: "relative", display: "inline-block" }}
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
                onMouseMove={handleMove}
            >
                <img
                    ref={imgRef}
                    src={src}
                    alt=""
                    style={{ maxWidth: "100%", display: "block", height: "auto" }}
                />

                {/* LENS */}
                {show && (
                    <div
                        style={{
                            position: "absolute",
                            width: lensSize,
                            height: lensSize,
                            border: "1px solid #000",
                            background: "rgba(255,255,255,.25)",
                            pointerEvents: "none",
                            left: pos.x - half,
                            top: pos.y - half
                        }}
                    />
                )}
            </div>

            {/* ZOOM PANEL */}
            {show && (
                <div
                    style={{
                        position: "fixed",
                        top: zoomPos.top,
                        left: zoomPos.left,
                        width: zoomWidth,
                        height: zoomHeight,
                        border: "1px solid #ccc",
                        backgroundImage: `url(${src})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: `${zoom * 100}%`,
                        backgroundPosition: bgPos,
                        zIndex: 9999,
                        backgroundColor: "#fff",
                    }}
                />
            )}
        </>
    );
}